// Based on https://getbootstrap.com/docs/4.4/layout/overview/#responsive-breakpoints
const breakpoints = {
  xs: 575,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

export const desktop: number = breakpoints.lg;
export const tablet: number = breakpoints.md;

if (!import.meta.env.PROD) {
  Object.freeze(breakpoints);
}

export default breakpoints;

export type Breakpoints = Readonly<typeof breakpoints>;
export type BreakpointsKeys = keyof typeof breakpoints;
